import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    [$theme.mediaQuery.large]: {
        width: '100%'
    }
}))

export const InputWrapper = styled<'div', { $whiteBg?: boolean }>('div', ({ $theme }) => ({
    width: '100%',
    height: '5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid #EAECF0`,
    borderRadius: '2.4rem',
    padding: '1.2rem 2rem',

    // focused
    ':focus-within': {
        border: `1px solid ${$theme.colors.primary}`
    }
}))

export const IconCircleWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    flex: '0 0 auto',
    cursor: 'pointer'
}))

export const Icon = styled<
    'i',
    { $clickable?: boolean; $white?: boolean; $rightMargin?: boolean; $locationIcon?: boolean }
>('i', ({ $theme, $clickable = false, $white = false, $rightMargin = false, $locationIcon = false }) => ({
    color: $white ? $theme.colors.white : $locationIcon ? $theme.colors.primary : '#000',
    fontSize: '1.6rem',
    cursor: $clickable ? 'pointer' : 'default',
    marginRight: $rightMargin ? '0.8rem' : 0,
    fontWeight: 300
}))

export const EnterErrorMessage = styled('div', ({ $theme }) => ({
    marginTop: '0.5rem',
    color: '#D92D20',
    fontSize: '1.4rem',
    fontWeight: 500,
    marginBottom: '2rem'
}))

export const AutocompleteInput = styled('input', ({ $theme }) => ({
    fontSize: '1.6rem',
    color: '#000',
    fontWeight: 300,
    lineHeight: '2.4rem',
    width: '100%',
    height: '100%',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',

    '::placeholder': {
        color: '#B3BBC7',
        fontSize: '1.6rem',
        fontWeight: 300,
        lineHeight: '2.4rem'
    }
}))
